import { useMemo } from 'react'
import { IMAGE_RESOLUTIONS } from 'components/HomepageCarousel/Carousel/constants'
import { useSpringboardCarouselData } from '../hooks'
import { SpringboardCarouselTile } from './SpringboardCarouselTile'

const imageWidth = IMAGE_RESOLUTIONS.sm.width
const imageHeight = IMAGE_RESOLUTIONS.sm.height

export const HorizontalSpringboardCarousel = () => {
  const carouselSpringboardItems = useSpringboardCarouselData()

  const { row1Items, row2Items } = useMemo(() => {
    const row1 = carouselSpringboardItems.filter((_, idx) => idx % 2 === 0)
    const row2 = carouselSpringboardItems.filter((_, idx) => idx % 2 === 1)

    return {
      row1Items: row1.concat(row1),
      row2Items: row2.concat(row2),
    }
  }, [carouselSpringboardItems])

  return (
    <>
      <div className='d-flex flex-nowrap'>
        {row1Items.map((item, index) => (
          <div
            key={`row1-${index}`}
            className='mc-mr-3'
            style={{
              transform: 'translateX(0%)', // Ensures the nameplateImage is anchored to its tile
            }}
          >
            <SpringboardCarouselTile
              uuid={item.uuid}
              slug={item.slug}
              itemType={item.itemType}
              imageURL={item.carouselImageURL}
              height={imageHeight}
              width={imageWidth}
              title={item.title}
              nameplateImage={item.nameplateImage}
              categoryId={item.primaryCategory?.id}
              size='sm'
            />
          </div>
        ))}
      </div>
      <div className='d-flex flex-nowrap mc-mt-3'>
        {row2Items.map((item, index) => (
          <div
            key={`row2-${index}`}
            className='mc-mr-3'
            style={{
              transform: 'translateX(-50%)', // Creates the running bond brick/staggered layout effect
            }}
          >
            <SpringboardCarouselTile
              uuid={item.uuid}
              itemType={item.itemType}
              imageURL={item.carouselImageURL}
              height={imageHeight}
              width={imageWidth}
              title={item.title}
              nameplateImage={item.nameplateImage}
              categoryId={item.primaryCategory?.id}
              size='sm'
              slug={item.slug}
            />
          </div>
        ))}
      </div>
    </>
  )
}
